"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaDeliveryBlockWatcher = _interopRequireDefault(require("../../events/bwa-delivery-block-watcher"));
var _utils = require("../../utils/utils");
var _constants = require("../../constants/constants");
var _bwaDeliveryBlock = require("../../apis/bwa/widgets/bwa-delivery-block");
var _bwaInputPincode = require("../../apis/bwa/widgets/bwa-input-pincode");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaDeliveryBlockRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaDeliveryBlockRenderHandler(validateSkuResponse) {
    var _this;
    (0, _classCallCheck2["default"])(this, BwaDeliveryBlockRenderHandler);
    _this = _callSuper(this, BwaDeliveryBlockRenderHandler);
    _this.storeId = window.storeId;
    _this.validateSkuResponse = validateSkuResponse;
    _this.isInStock = null;
    _this.tInjected = null;
    _this.perceivedLogged = false;
    _this.pre.push(function () {
      _this.config = window.bwaMerchantConfig.bwaDeliveryBlock;
      _this.variantIdSelector = _this.config.variantIdSelector;
      _this.variantId = (0, _utils.getVariantId)(_this.variantIdSelector);
      _this.itemQuantitySelector = _this.config.itemQuantitySelector;
      _this.bwaDeliveryBlockId = "bwa-delivery-block-iframe";
      _this.bwaDeliveryBlockPositionSelector = _this.config && _this.config.bwaDeliveryBlockPositionSelector || "";
      _this.bwaDeliveryBlockCSSClass = "bwa-delivery-block";
      _this.bwaDeliveryBlockContainerId = _constants.BWA_WIDGET_CONTAINER_IDS.BWA_DELIVERY_BLOCK_CONTAINER_ID;
      _this.bwaInputPincodeModalId = 'bwa-input-pincode-modal';
      _this.bwaInputPincodeModalClass = 'bwa-input-pincode-modal';
      _this.bwaInputPincodeIframeId = 'bwa-input-pincode';
      _this.bwaInputPincodeIframeClass = 'bwa-input-pincode';
    });
    return _this;
  }
  (0, _inherits2["default"])(BwaDeliveryBlockRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaDeliveryBlockRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
              this.setupEventListeners();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this$validateSkuResp, _this$validateSkuResp2;
        var validateStoreResponse;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU, (_this$validateSkuResp = this.validateSkuResponse) === null || _this$validateSkuResp === void 0 ? void 0 : _this$validateSkuResp.isSkuEnabled);
              if ((_this$validateSkuResp2 = this.validateSkuResponse) !== null && _this$validateSkuResp2 !== void 0 && _this$validateSkuResp2.isSkuEnabled) {
                this.injectBwADeliveryBlockIframe(_constants.DEFAULT_QUANTITY);
              }
              validateStoreResponse = window.bwaValidateStoreResponse;
              if (validateStoreResponse !== null && validateStoreResponse !== void 0 && validateStoreResponse.isStoreBwAEnabled) {
                sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.CLIENT_ID, validateStoreResponse.clientId);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "injectBwADeliveryBlockIframe",
    value: function injectBwADeliveryBlockIframe(ecpSkuQuantity) {
      new _bwaDeliveryBlockWatcher["default"]();
      var bwaDeliveryBlockIframe = (0, _bwaDeliveryBlock.bwaDeliveryBlockWidget)(this.bwaDeliveryBlockId, this.bwaDeliveryBlockCSSClass, ecpSkuQuantity, this.storeId, this.variantId);
      this.tInjected = performance.now();
      this.perceivedLogged = false;
      (0, _utils.insertElementWithFallback)(this.bwaDeliveryBlockContainerId, bwaDeliveryBlockIframe, this.bwaDeliveryBlockPositionSelector);
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      var quantityInput = (0, _utils.safeQuerySelector)(this.itemQuantitySelector);
      if (quantityInput) {
        quantityInput.addEventListener(_constants.EVENT_TYPE.CHANGE, function () {
          _this2.clearBwADeliveryBlock();
          _this2.updateIframeQuantity();
        });
      }
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.VARIANT_UPDATED, /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.trackVariantButtons(event.detail.validateSkuResponse);
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data, _event$data2, _event$data3, _event$data5, _event$data6, _event$data7;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) === _constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_BLOCK_EDIT_CLICKED) {
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CLICK_UPDATE_ADDRESS_PDP));
          _this2.injectInputPincodeIframe();
        } else if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.type) === _constants.EVENT_TYPE.CUSTOM.BWA_PINCODE_MODAL_CLOSED) {
          _this2.closeInputPincodeIframe();
        } else if (((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.type) === _constants.EVENT_TYPE.CUSTOM.BWA_PINCODE_APPLIED) {
          var _event$data4;
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_CLICK_APPLY_PINCODE_BUTTON));
          sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.PINCODE, (_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.pincode);
          _this2.clearBwADeliveryBlock();
          _this2.updateIframeQuantity();
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.RESOLVE_CHECKOUT_OPTIONS));
        } else if (((_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.type) === _constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_BLOCK_RENDERED) {
          _this2.closeInputPincodeIframe();
          var deliveryBlockIframe = (0, _utils.safeGetElementById)(_this2.bwaDeliveryBlockId);
          if (deliveryBlockIframe) {
            deliveryBlockIframe.style.height = event.data.height + "px";
          }
          // Only the AJAX-success message carries isInStock; the bare window.load one has no
          // payload and can fire before the content is there.
          if ('isInStock' in event.data && !_this2.perceivedLogged) {
            _this2.perceivedLogged = true;
            (0, _katalFunnelEvents.logPerceived)("delivery_block", {
              tInjected: _this2.tInjected,
              signalType: "content_visible",
              extra: {
                is_in_stock: String(event.data.isInStock)
              }
            });
          }
          if ('isInStock' in event.data && _this2.isInStock !== event.data.isInStock) {
            _this2.isInStock = event.data.isInStock;
            if (_this2.isInStock) {
              var _safeGetElementById;
              (_safeGetElementById = (0, _utils.safeGetElementById)(_this2.bwaDeliveryBlockId)) === null || _safeGetElementById === void 0 || _safeGetElementById.remove();
              _this2.updateIframeQuantity();
            }
          }
        } else if (((_event$data6 = event.data) === null || _event$data6 === void 0 ? void 0 : _event$data6.type) === _constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_BLOCK_POPUP_OPENED) {
          _this2.showPrepaidInfoPopup();
        } else if (((_event$data7 = event.data) === null || _event$data7 === void 0 ? void 0 : _event$data7.type) === _constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_BLOCK_POPUP_CLOSED) {
          _this2.closePrepaidInfoPopup();
        }
      });
    }
  }, {
    key: "clearBwADeliveryBlock",
    value: function clearBwADeliveryBlock() {
      var _safeGetElementById2;
      (_safeGetElementById2 = (0, _utils.safeGetElementById)(this.bwaDeliveryBlockId)) === null || _safeGetElementById2 === void 0 || _safeGetElementById2.remove();
      this.isInStock = null;
    }
  }, {
    key: "updateIframeQuantity",
    value: function updateIframeQuantity() {
      var quantityInput = (0, _utils.safeQuerySelector)(this.itemQuantitySelector);
      var selectedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      if (sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU) === _constants.SESSION_STORAGE_VALUES.TRUE) {
        this.injectBwADeliveryBlockIframe(selectedQuantity);
      }
    }
  }, {
    key: "trackVariantButtons",
    value: function () {
      var _trackVariantButtons = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(validateSkuResponseAfterVariantChange) {
        var currentVariantId, _this$validateSkuResp3, _this$validateSkuResp4;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              currentVariantId = (0, _utils.getVariantId)(this.variantIdSelector) || (0, _utils.getVariantIdFromURL)();
              if (currentVariantId && currentVariantId !== this.variantId) {
                this.variantId = currentVariantId;
                this.validateSkuResponse = validateSkuResponseAfterVariantChange;
                sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_SKU, (_this$validateSkuResp3 = this.validateSkuResponse) === null || _this$validateSkuResp3 === void 0 ? void 0 : _this$validateSkuResp3.isSkuEnabled.toString());
                this.clearBwADeliveryBlock();
                if ((_this$validateSkuResp4 = this.validateSkuResponse) !== null && _this$validateSkuResp4 !== void 0 && _this$validateSkuResp4.isSkuEnabled) {
                  this.updateIframeQuantity();
                }
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function trackVariantButtons(_x2) {
        return _trackVariantButtons.apply(this, arguments);
      }
      return trackVariantButtons;
    }()
  }, {
    key: "injectInputPincodeIframe",
    value: function injectInputPincodeIframe() {
      var _this3 = this;
      var inputPincodeModalContainer = document.createElement("div");
      inputPincodeModalContainer.id = this.bwaInputPincodeModalId;
      inputPincodeModalContainer.className = this.bwaInputPincodeModalClass;
      var iframe = (0, _bwaInputPincode.bwaInputPincodeWidget)(this.bwaInputPincodeIframeId, this.bwaInputPincodeIframeClass);
      inputPincodeModalContainer.appendChild(iframe);
      document.body.insertBefore(inputPincodeModalContainer, document.body.firstChild);
      inputPincodeModalContainer.classList.add('active');
      inputPincodeModalContainer.addEventListener('click', function (event) {
        if (event.target === inputPincodeModalContainer) {
          _this3.closeInputPincodeIframe();
        }
      });
    }
  }, {
    key: "showPrepaidInfoPopup",
    value: function showPrepaidInfoPopup() {
      var _this4 = this;
      if (this.prepaidInfoOverlay || this.prepaidInfoModal) {
        return;
      }
      this.prepaidInfoOverlay = document.createElement('div');
      this.prepaidInfoOverlay.className = 'bwa-prepaid-info-overlay';
      this.prepaidInfoModal = document.createElement('div');
      this.prepaidInfoModal.className = 'bwa-prepaid-info-modal';
      this.prepaidInfoModal.innerHTML = "\n            <button class=\"bwa-prepaid-info-modal-close\" aria-label=\"Close\">\n                <img src=\"https://m.media-amazon.com/images/G/31/BuyWithAmazon/cross.svg\" alt=\"\" width=\"16\" height=\"16\" />\n            </button>\n            <div class=\"bwa-prepaid-info-modal-title\">Delivery Information</div>\n            <div class=\"bwa-prepaid-info-modal-body\">COD orders will be delivered within 2 to 4 days.</div>\n        ";
      document.body.appendChild(this.prepaidInfoOverlay);
      document.body.appendChild(this.prepaidInfoModal);
      this.prepaidInfoOverlay.addEventListener('click', function () {
        return _this4.closePrepaidInfoPopup();
      });
      this.prepaidInfoModal.querySelector('.bwa-prepaid-info-modal-close').addEventListener('click', function () {
        return _this4.closePrepaidInfoPopup();
      });
    }
  }, {
    key: "closePrepaidInfoPopup",
    value: function closePrepaidInfoPopup() {
      var _this$prepaidInfoOver, _this$prepaidInfoModa;
      (_this$prepaidInfoOver = this.prepaidInfoOverlay) === null || _this$prepaidInfoOver === void 0 || _this$prepaidInfoOver.remove();
      (_this$prepaidInfoModa = this.prepaidInfoModal) === null || _this$prepaidInfoModa === void 0 || _this$prepaidInfoModa.remove();
      this.prepaidInfoOverlay = null;
      this.prepaidInfoModal = null;
    }
  }, {
    key: "closeInputPincodeIframe",
    value: function closeInputPincodeIframe() {
      var _safeGetElementById3;
      (_safeGetElementById3 = (0, _utils.safeGetElementById)(this.bwaInputPincodeModalId)) === null || _safeGetElementById3 === void 0 || _safeGetElementById3.remove();
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-delivery-block-render-handler.js.map
